import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';
import {
  getRateTypes,
  getRateTypesSuccess,
} from './rate-type.actions';
import { RateTypeService } from './rate-type.service';
import { loadError } from '../error/error.action';
import { createActionError } from '../../models/action-error';

@Injectable()
export class RateTypeEffects {
  constructor(
    private actions$: Actions,
    private rateTypeService: RateTypeService
  ) {}

  public getRateTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getRateTypes),
      concatMap(() =>
        this.rateTypeService.getRateTypes().pipe(
          map((response) =>
            getRateTypesSuccess({
              rateTypes: response.data,
            })
          ),
          catchError((error) => {
            return of(
              loadError(
                createActionError(error.message ?? 'Get Rate Types Failed.')
              )
            );
          })
        )
      )
    )
  );
}
